import React from 'react';

import { Translate } from 'react-localize-redux';
import { type RouteComponentProps, Route, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';
import Permissions from '@fd/ui/Permissions';

import { toKebabCase } from '../../../helpers/strings';
import { lazyWithRetry } from '../../../helpers/utilities';
import ErrorBoundary from '../../../layouts/Portal/ErrorBoundary';
import { RMSModules } from '../utils/rmsModules';
import { RMSSubscriptions } from '../utils/rmsSubscriptions';

const RMSPage = lazyWithRetry(() => import('../components/RMSPage'));
const Payroll = lazyWithRetry(() => import('./Payroll'));

const PayrollRoutes: React.FC<React.PropsWithChildren<RouteComponentProps>> = (
  props: RouteComponentProps
) => {
  const {
    match: { path },
  } = props;
  const baseUrl = `modules/payroll`;
  return (
    <ErrorBoundary identifier="payroll">
      <Switch>
        <Route
          exact
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <Payroll />
            </LazyComponent>
          )}
        />
        <Route
          exact
          path={`${path}/${toKebabCase(RMSModules.ROTA)}`}
          render={() => (
            <Permissions allowed={['ViewPayrollRota', 'EditPayrollRota']}>
              <LazyComponent>
                <RMSPage
                  noMaxWidth
                  subscription={RMSSubscriptions.PAYROLL}
                  title={<Translate id="Rota" />}
                  module={RMSModules.ROTA}
                  url={`${baseUrl}/${RMSModules.ROTA}`}
                  includePropertyIdInUrl
                  editPermissions={['EditPayrollRota']}
                />
              </LazyComponent>
            </Permissions>
          )}
        />
        <Route
          exact
          path={`${path}/${toKebabCase(RMSModules.PAYROLL_CALCULATOR)}`}
          render={() => (
            <Permissions allowed={['ViewPayrollRota', 'EditPayrollRota']}>
              <LazyComponent>
                <RMSPage
                  subscription={RMSSubscriptions.PAYROLL}
                  title={<Translate id="Payroll_Calculator" />}
                  module={RMSModules.PAYROLL_CALCULATOR}
                  url={`${baseUrl}/${RMSModules.PAYROLL_CALCULATOR}`}
                  includePropertyIdInUrl
                  editPermissions={['EditPayrollRota']}
                />
              </LazyComponent>
            </Permissions>
          )}
        />
        <Route
          exact
          path={`${path}/${toKebabCase(RMSModules.HOLIDAY_PLANNER)}`}
          render={() => (
            <Permissions allowed={['ViewPayrollHoliday', 'EditPayrollHoliday']}>
              <LazyComponent>
                <RMSPage
                  subscription={RMSSubscriptions.PAYROLL}
                  title={<Translate id="Holiday_Planner" />}
                  module={RMSModules.HOLIDAY_PLANNER}
                  url={`${baseUrl}/${RMSModules.HOLIDAY_PLANNER}`}
                  includePropertyIdInUrl
                  editPermissions={['EditPayrollHoliday']}
                />
              </LazyComponent>
            </Permissions>
          )}
        />
        <Route
          exact
          path={`${path}/${toKebabCase(RMSModules.PAYROLL_CONFIGURATION)}`}
          render={() => (
            <Permissions allowed={['EditPayrollRota']}>
              <LazyComponent>
                <RMSPage
                  subscription={RMSSubscriptions.BASE}
                  title={<Translate id="Payroll_Configuration" />}
                  module={RMSModules.PAYROLL_CONFIGURATION}
                  url={`configurations/franchisors/properties/${RMSModules.PAYROLL_CONFIGURATION}`}
                  includePropertyIdInUrl
                  editPermissions={['EditPayrollRota']}
                />
              </LazyComponent>
            </Permissions>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default PayrollRoutes;
